<template>
  <div>
    <ListagemBase
      nomePlural="Usuarios"
      nomeSingular="Usuario"
      :headers="headers"
      stringCadastro="Novo_usuario"
      :buscaSimplificada="false"
      :pesquisaNomeCpf="true"
      :pesquisaStatusComum="true"
      :enableSelection="true"
      :buscaParametrizadaPaginada="true"
      :bulkActions="bulkActionsUsuarios"
      bulkActionStatusField="statusComum"
    >
      <template v-slot:upload> </template>
    </ListagemBase>

    <v-dialog
      v-model="dialogClonarPerfis"
      persistent
      max-width="800"
      scrollable
      class="clone-profiles-dialog"
    >
      <v-card>
        <v-card-title class="clone-profiles-title px-6 pt-5">
          <v-icon class="mr-2" color="primary">
            mdi-account-switch-outline
          </v-icon>
          {{ $t("Clonar_perfis") }}
        </v-card-title>
        <v-card-subtitle class="px-6 pb-2">
          {{ $t("Clonar_perfis_ajuda") }}
        </v-card-subtitle>

        <v-card-text class="px-6 pt-3">
          <section class="clone-profiles-section">
            <div class="clone-profiles-section__heading">
              <span class="clone-profiles-step">1</span>
              <div>
                <strong>{{ $t("Usuario_origem") }}</strong>
                <div class="clone-profiles-hint">
                  {{ $t("Escolha_usuario_origem_ajuda") }}
                </div>
              </div>
            </div>
            <v-autocomplete
              v-model="usuarioOrigemClonagem"
              :items="usuariosClonagem"
              :item-text="formatarUsuarioClonagem"
              item-value="id"
              return-object
              :label="$t('Usuario_origem')"
              prepend-inner-icon="mdi-account-key-outline"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
                mt-3
              "
              dense
              flat
              filled
              solo
              hide-details="auto"
              :disabled="loadingClonagemPerfis"
            />
          </section>

          <section class="clone-profiles-section">
            <div class="clone-profiles-section__heading">
              <span class="clone-profiles-step">2</span>
              <div>
                <strong>{{ $t("Perfis_para_clonar") }}</strong>
                <div class="clone-profiles-hint">
                  {{ $t("Perfis_do_inquilino_atual_ajuda") }}
                </div>
              </div>
            </div>
            <v-progress-linear
              v-if="carregandoPerfisOrigem"
              indeterminate
              color="primary"
              class="mt-4"
            />
            <v-alert
              v-else-if="erroPerfisOrigem"
              type="error"
              dense
              text
              class="mt-4 mb-0"
            >
              {{ erroPerfisOrigem }}
              <v-btn text small color="error" @click="carregarPerfisOrigem">
                {{ $t("Tentar_novamente") }}
              </v-btn>
            </v-alert>
            <v-alert
              v-else-if="usuarioOrigemClonagem && !perfisOrigemClonagem.length"
              type="info"
              dense
              text
              class="mt-4 mb-0"
            >
              {{ $t("Origem_sem_perfis_no_inquilino") }}
            </v-alert>
            <template v-else-if="perfisOrigemClonagem.length">
              <v-radio-group
                v-model="modoPerfisClonagem"
                hide-details
                class="clone-profiles-options mt-3"
                :disabled="loadingClonagemPerfis"
              >
                <v-radio
                  value="todos"
                  :label="$t('Todos_os_perfis_da_origem')"
                />
                <v-radio
                  value="selecionados"
                  :label="$t('Escolher_perfis_da_origem')"
                />
              </v-radio-group>
              <div class="clone-profiles-list mt-3">
                <div class="clone-profiles-list__toolbar">
                  <span
                    >{{ idsPerfisExibidos.length }} /
                    {{ perfisOrigemClonagem.length }} {{ $t("Perfis") }}</span
                  >
                  <v-btn
                    v-if="modoPerfisClonagem === 'selecionados'"
                    text
                    small
                    color="primary"
                    :disabled="loadingClonagemPerfis"
                    @click="alternarTodosPerfis"
                  >
                    {{
                      todosPerfisSelecionados
                        ? $t("Desmarcar_todos")
                        : $t("Selecionar_todos")
                    }}
                  </v-btn>
                </div>
                <div class="clone-profiles-list__items">
                  <v-checkbox
                    v-for="item in perfisOrigemClonagem"
                    :key="item.perfil.id"
                    v-model="idsPerfisExibidos"
                    :value="item.perfil.id"
                    :label="item.perfil.descricao"
                    color="primary"
                    hide-details
                    class="clone-profiles-checkbox"
                    :readonly="modoPerfisClonagem === 'todos'"
                    :disabled="loadingClonagemPerfis"
                  />
                </div>
              </div>
            </template>
          </section>

          <section class="clone-profiles-section">
            <div class="clone-profiles-section__heading">
              <span class="clone-profiles-step">3</span>
              <div>
                <strong>{{ $t("Usuarios_destino") }}</strong>
                <div class="clone-profiles-hint">
                  {{ $t("Escolha_usuarios_destino_ajuda") }}
                </div>
              </div>
            </div>
            <div class="clone-profiles-list mt-3">
              <div class="clone-profiles-list__toolbar">
                <span
                  >{{ idsUsuariosDestinoClonagem.length }} /
                  {{ usuariosDestinoDisponiveis.length }}
                  {{ $t("Usuarios_destino") }}</span
                >
                <v-btn
                  text
                  small
                  color="primary"
                  :disabled="loadingClonagemPerfis"
                  @click="alternarTodosDestinos"
                >
                  {{
                    todosDestinosSelecionados
                      ? $t("Desmarcar_todos")
                      : $t("Selecionar_todos")
                  }}
                </v-btn>
              </div>
              <div class="clone-profiles-list__items">
                <v-checkbox
                  v-for="usuario in usuariosDestinoDisponiveis"
                  :key="usuario.id"
                  v-model="idsUsuariosDestinoClonagem"
                  :value="usuario.id"
                  color="primary"
                  hide-details
                  class="clone-profiles-checkbox"
                  :disabled="loadingClonagemPerfis"
                >
                  <template v-slot:label>
                    <span class="clone-profiles-user">
                      <strong>{{ nomeUsuario(usuario) }}</strong>
                      <small v-if="subtituloUsuario(usuario)">{{
                        subtituloUsuario(usuario)
                      }}</small>
                    </span>
                  </template>
                </v-checkbox>
              </div>
            </div>
          </section>

          <v-alert type="warning" text dense class="mt-5 mb-0">
            {{ $t("Perfis_serao_substituidos_destinos") }}
          </v-alert>
        </v-card-text>

        <v-card-actions class="px-6 pb-5">
          <v-spacer />
          <v-btn
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            :disabled="loadingClonagemPerfis"
            @click="cancelarClonagemPerfis"
          >
            {{ $t("Cancelar") }}
          </v-btn>
          <v-btn
            height="39"
            class="
              ma-1
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              py-3
              px-6
              ms-3
            "
            :loading="loadingClonagemPerfis"
            :disabled="!podeConfirmarClonagemPerfis"
            @click="confirmarClonagemPerfis"
          >
            {{ $t("Clonar_perfis") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ResultadoEnvioSenhas
      :value="dialogResultadoEnvioSenhas"
      :processando="processandoEnvioSenhas"
      :itens="resultadosEnvioSenhas"
      @close="dialogResultadoEnvioSenhas = false"
    />
  </div>
</template>

<script>
import DataService from "@/services/acessos/UsuarioDataService";

import ListagemBase from "@/components/base/Crud/ListagemBase";
import ResultadoEnvioSenhas from "./ResultadoEnvioSenhas.vue";
import {
  classificarFalhaEnvioSenha,
  processarEnvioNovaSenhaEmMassa,
} from "@/utils/envioNovaSenhaEmMassa";
export default {
  name: "ListagemUsuarios",
  components: { ListagemBase, ResultadoEnvioSenhas },
  computed: {
    bulkActionsUsuarios() {
      return [
        {
          value: "clonarPerfis",
          text: this.$t("Clonar_perfis"),
          handler: this.abrirClonagemPerfis,
          successMessage: false,
          refreshAfter: false,
        },
        {
          value: "changePasswordRandomly",
          text: this.$t("Enviar_nova_senha"),
          statuses: ["ATIVO"],
          handler: this.enviarNovasSenhasEmMassa,
          successMessage: false,
          errorMessage: this.$t("Nao_foi_possivel_enviar_nova_senha"),
          confirmTitle: this.$t("Enviar_nova_senha"),
          confirmMessage: this.$t("Confirmar_envio_nova_senha_usuarios"),
          refreshAfter: false,
        },
      ];
    },
    usuariosDestinoDisponiveis() {
      if (!this.usuarioOrigemClonagem) {
        return [];
      }
      return this.usuariosClonagem.filter((usuario) => {
        return usuario?.id !== this.usuarioOrigemClonagem?.id;
      });
    },
    todosPerfisSelecionados() {
      return (
        this.perfisOrigemClonagem.length > 0 &&
        this.idsPerfisSelecionados.length === this.perfisOrigemClonagem.length
      );
    },
    idsPerfisExibidos: {
      get() {
        return this.modoPerfisClonagem === "todos"
          ? this.perfisOrigemClonagem.map((item) => item.perfil.id)
          : this.idsPerfisSelecionados;
      },
      set(ids) {
        if (this.modoPerfisClonagem === "selecionados") {
          this.idsPerfisSelecionados = ids;
        }
      },
    },
    todosDestinosSelecionados() {
      return (
        this.usuariosDestinoDisponiveis.length > 0 &&
        this.idsUsuariosDestinoClonagem.length ===
          this.usuariosDestinoDisponiveis.length
      );
    },
    podeConfirmarClonagemPerfis() {
      return (
        !!this.usuarioOrigemClonagem &&
        !this.carregandoPerfisOrigem &&
        !this.erroPerfisOrigem &&
        this.perfisOrigemClonagem.length > 0 &&
        (this.modoPerfisClonagem === "todos" ||
          this.idsPerfisSelecionados.length > 0) &&
        this.idsUsuariosDestinoClonagem.length > 0 &&
        !this.loadingClonagemPerfis
      );
    },
  },

  data() {
    return {
      DataService: DataService,
      dialogClonarPerfis: false,
      usuariosClonagem: [],
      usuarioOrigemClonagem: null,
      perfisOrigemClonagem: [],
      idsPerfisSelecionados: [],
      modoPerfisClonagem: "todos",
      idsUsuariosDestinoClonagem: [],
      carregandoPerfisOrigem: false,
      erroPerfisOrigem: "",
      requisicaoPerfisOrigem: 0,
      loadingClonagemPerfis: false,
      resolverClonagemPerfis: null,
      listagemClonagemPerfis: null,
      dialogResultadoEnvioSenhas: false,
      processandoEnvioSenhas: false,
      resultadosEnvioSenhas: [],

      headers: [
        { text: this.$t("Nome"), value: "pessoa.nome", sortable: "false" },
        { text: this.$t("Email_ou_cpf"), value: "email", sortable: "false" },
        { text: this.$t("Status"), value: "statusComum", sortable: "false" },

        { text: this.$t("Acoes"), value: "actions", sortable: false },
      ],
    };
  },
  watch: {
    usuarioOrigemClonagem() {
      this.modoPerfisClonagem = "todos";
      this.idsPerfisSelecionados = [];
      this.idsUsuariosDestinoClonagem = this.usuariosDestinoDisponiveis.map(
        (usuario) => usuario.id
      );
      this.carregarPerfisOrigem();
    },
  },
  methods: {
    async enviarNovasSenhasEmMassa(usuarios) {
      this.resultadosEnvioSenhas = usuarios.map((usuario, indice) => ({
        chave: `${usuario?.id ?? "sem-id"}-${indice}`,
        usuario,
        nome: this.nomeUsuario(usuario) || this.$t("Usuario"),
        email: usuario?.pessoa?.email?.trim() || "",
        status: "pendente",
        motivo: "",
      }));
      this.processandoEnvioSenhas = true;
      this.dialogResultadoEnvioSenhas = true;

      let resultados;
      try {
        resultados = await processarEnvioNovaSenhaEmMassa(
          usuarios,
          (usuario) => {
            if (usuario?.id == null) {
              const error = new Error(
                this.$t("Usuario_sem_identificador_envio_senha")
              );
              error.code = "USUARIO_SEM_ID";
              throw error;
            }
            return DataService.changePasswordRandomly(usuario);
          },
          (indice, resultado) => {
            this.$set(this.resultadosEnvioSenhas, indice, {
              ...this.resultadosEnvioSenhas[indice],
              ...resultado,
            });
          },
          (error) => {
            if (error?.code === "USUARIO_SEM_ID") {
              return { status: "falha", motivo: error.message };
            }
            return classificarFalhaEnvioSenha(
              error,
              (key) => this.$t(key),
              (apiError, fallback) =>
                this.getMensagemErroApi(apiError, fallback)
            );
          }
        );
      } finally {
        this.processandoEnvioSenhas = false;
      }
      return {
        successCount: resultados.filter((item) => item.status === "enviado")
          .length,
      };
    },

    abrirClonagemPerfis(rows, helpers = {}) {
      if (!Array.isArray(rows) || rows.length < 2) {
        this.$swal.fire(
          this.$t("Atencao"),
          this.$t("Selecione_ao_menos_dois_usuarios_clonar_perfis"),
          "warning"
        );
        return Promise.resolve();
      }

      this.usuariosClonagem = rows.filter((usuario) => usuario?.id != null);
      this.usuarioOrigemClonagem = rows[0];
      this.listagemClonagemPerfis = helpers.listagem || null;
      this.dialogClonarPerfis = true;

      return new Promise((resolve) => {
        this.resolverClonagemPerfis = resolve;
      });
    },

    carregarPerfisOrigem() {
      const idOrigem = this.usuarioOrigemClonagem?.id;
      const requisicao = ++this.requisicaoPerfisOrigem;
      this.perfisOrigemClonagem = [];
      this.idsPerfisSelecionados = [];
      this.erroPerfisOrigem = "";
      this.carregandoPerfisOrigem = !!idOrigem;
      if (!idOrigem) {
        return;
      }

      DataService.findPerfisParaClonagem(idOrigem)
        .then((response) => {
          if (requisicao !== this.requisicaoPerfisOrigem) {
            return;
          }
          const perfis = Array.isArray(response.data) ? response.data : [];
          this.perfisOrigemClonagem = perfis.filter(
            (item) => item?.perfil?.id != null
          );
        })
        .catch((error) => {
          if (requisicao !== this.requisicaoPerfisOrigem) {
            return;
          }
          this.erroPerfisOrigem = this.getMensagemErroApi(
            error,
            this.$t("Nao_foi_possivel_carregar_perfis_origem")
          );
        })
        .finally(() => {
          if (requisicao === this.requisicaoPerfisOrigem) {
            this.carregandoPerfisOrigem = false;
          }
        });
    },

    alternarTodosPerfis() {
      this.idsPerfisSelecionados = this.todosPerfisSelecionados
        ? []
        : this.perfisOrigemClonagem.map((item) => item.perfil.id);
    },

    alternarTodosDestinos() {
      this.idsUsuariosDestinoClonagem = this.todosDestinosSelecionados
        ? []
        : this.usuariosDestinoDisponiveis.map((usuario) => usuario.id);
    },

    cancelarClonagemPerfis() {
      if (this.loadingClonagemPerfis) {
        return;
      }
      this.fecharClonagemPerfis();
      this.finalizarAcaoClonagemPerfis();
    },

    confirmarClonagemPerfis() {
      if (!this.podeConfirmarClonagemPerfis) {
        return;
      }

      this.loadingClonagemPerfis = true;
      const payload = {
        idUsuarioOrigem: this.usuarioOrigemClonagem.id,
        idsUsuariosDestino: this.idsUsuariosDestinoClonagem,
      };
      if (this.modoPerfisClonagem === "selecionados") {
        payload.idsPerfis = this.idsPerfisSelecionados;
      }
      DataService.clonarPerfis(payload)
        .then(() => {
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Perfis_clonados_com_sucesso"),
            "success"
          );
          if (
            this.listagemClonagemPerfis &&
            typeof this.listagemClonagemPerfis.refreshList === "function"
          ) {
            this.listagemClonagemPerfis.refreshList();
          }
          this.fecharClonagemPerfis();
          this.finalizarAcaoClonagemPerfis();
        })
        .catch((error) => {
          console.log(error);
          this.$swal.fire(
            this.$t("Erro"),
            this.getMensagemErroApi(error),
            "error"
          );
        })
        .finally(() => {
          this.loadingClonagemPerfis = false;
        });
    },

    fecharClonagemPerfis() {
      this.dialogClonarPerfis = false;
      this.usuariosClonagem = [];
      this.usuarioOrigemClonagem = null;
      this.perfisOrigemClonagem = [];
      this.idsPerfisSelecionados = [];
      this.idsUsuariosDestinoClonagem = [];
      this.erroPerfisOrigem = "";
      this.listagemClonagemPerfis = null;
    },

    finalizarAcaoClonagemPerfis() {
      if (typeof this.resolverClonagemPerfis === "function") {
        this.resolverClonagemPerfis();
      }
      this.resolverClonagemPerfis = null;
    },

    nomeUsuario(usuario) {
      return usuario?.pessoa?.nome || usuario?.email || "";
    },

    subtituloUsuario(usuario) {
      const dados = [];
      if (usuario?.email) {
        dados.push(usuario.email);
      }
      if (usuario?.pessoa?.cpf && usuario.pessoa.cpf !== usuario?.email) {
        dados.push(usuario.pessoa.cpf);
      }
      return dados.join(" - ");
    },

    formatarUsuarioClonagem(usuario) {
      const nome = this.nomeUsuario(usuario);
      const subtitulo = this.subtituloUsuario(usuario);
      return subtitulo ? `${nome} - ${subtitulo}` : nome;
    },

    getMensagemErroApi(
      error,
      mensagemPadrao = this.$t("Nao_foi_possivel_clonar_perfis")
    ) {
      const data = error?.response?.data;
      if (Array.isArray(data?.errors)) {
        const erro = data.errors.find(
          (item) => item?.message || item?.defaultMessage
        );
        if (erro) {
          return erro.message || erro.defaultMessage;
        }
      }
      if (typeof data?.message === "string" && data.message.trim()) {
        return data.message;
      }
      return mensagemPadrao;
    },
  },
};
</script>

<style scoped>
.clone-profiles-title {
  align-items: center;
  gap: 4px;
  word-break: normal;
}

.clone-profiles-section + .clone-profiles-section {
  border-top: 1px solid #e5e7eb;
  margin-top: 20px;
  padding-top: 20px;
}

.clone-profiles-section__heading {
  align-items: flex-start;
  color: #263244;
  display: flex;
  gap: 12px;
}

.clone-profiles-step {
  align-items: center;
  background: #e8edff;
  border-radius: 50%;
  color: #3b5ccc;
  display: inline-flex;
  flex: 0 0 26px;
  font-size: 0.8rem;
  font-weight: 700;
  height: 26px;
  justify-content: center;
}

.clone-profiles-hint {
  color: #64748b;
  font-size: 0.82rem;
  line-height: 1.4;
}

.clone-profiles-options {
  margin-left: 38px;
}

.clone-profiles-list {
  border: 1px solid #dce2eb;
  border-radius: 10px;
  overflow: hidden;
}

.clone-profiles-list__toolbar {
  align-items: center;
  background: #f8fafc;
  color: #475569;
  display: flex;
  font-size: 0.8rem;
  font-weight: 600;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: space-between;
  padding: 4px 8px 4px 16px;
}

.clone-profiles-list__items {
  max-height: 195px;
  overflow-y: auto;
  padding: 2px 12px 10px;
}

.clone-profiles-checkbox {
  margin: 8px 0 0;
  padding: 3px 4px;
}

.clone-profiles-user {
  display: flex;
  flex-direction: column;
  line-height: 1.35;
  min-width: 0;
}

.clone-profiles-user small {
  color: #64748b;
  overflow-wrap: anywhere;
}
</style>
